import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { SeoService } from '../../_services/seo/seo.service';

@Component({
    selector: 'app-page-not-found',
    imports: [],
    templateUrl: './page-not-found.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.set({
      title: 'Page introuvable',
      description: 'Cette page n\'existe pas ou a été déplacée.',
      path: '/404',
      noindex: true,
    });
  }
}
